export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_30.3e05a8a4.jpg";